import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSketchbook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sketchbook"><path d="M4.25 3.25V20.75H19.75V3.25H4.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 7.75H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 11.75H12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSketchbook;
